import React from "react"
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md"
import { MobergButton, MobergButtonShape } from "./MobergButton"
import { MobergTheme } from "../MobergThemes/MobergColors"
import { MobergIconSize } from "../MobergIcon/MobergIcon"

type MobergCheckboxProps = {
    isChecked: boolean
    onChange: (isChecked: boolean) => void
    theme?: MobergTheme
}

export const MobergCheckbox = ({ isChecked, onChange, theme }: MobergCheckboxProps) => {
    return (
        <MobergButton
            shape={MobergButtonShape.SQUARE}
            theme={theme ?? (isChecked ? MobergTheme.BLUE : MobergTheme.BLACK)}
            onClick={() => onChange(!isChecked)}
        >
            {isChecked
                ? <MdCheckBox size={MobergIconSize.REGULAR} />
                : <MdCheckBoxOutlineBlank size={MobergIconSize.REGULAR} />
            }
        </MobergButton>
    )
}
